module.exports = __webpack_public_path__ + "static/media/organization_chart.dcf37904.png";